import { createContext, useState } from "react";

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [contexStates, setContextStates] = useState({
    actualToken: "",
    profileTab: 0,
    paymentDetails: "",
  });

  return (
    <AppContext.Provider value={{ contexStates, setContextStates }}>
      {children}
    </AppContext.Provider>
  );
};
